import { createBrowserHistory } from 'history';

var History = createBrowserHistory();

export default History;
